(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["invest-in-envo"] && !window.DesignMode) return;
  try {
    
  console.log('script initiated')
     const dialog = document.getElementById('contact-form-popup')
      const buttons = document.querySelectorAll('.send-request')
     buttons.forEach((button)=>{
       button.addEventListener('click',()=>{
       console.log('Button clicked')
       dialog.classList.add('open')
       document.body.style.overflow ='hidden'
     })
     })
    dialog.addEventListener('click',(e)=>{
    const modalInner = document.querySelector('.contact-form-popup__inner');

      // Check if the click target is outside the inner part of the popup
      if (!modalInner.contains(event.target) && dialog.classList.contains('open') ) {
        dialog.classList.remove('open')
        document.body.style.overflow ='unset'
      }
  })
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["other-projects"] && !window.DesignMode) return;
  try {
    
  
              const cards = document.querySelectorAll('.project__card')
  cards.forEach((card)=>{
    const status = card.querySelector('.project__card__brief')?.querySelector('.project-status')
    if(status){
      card.querySelector('.project__status').innerHTML = `<b>Status:</b> ${status.innerHTML}`
    }
    else{
      
    }
  })
            

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project_page_projects_section"] && !window.DesignMode) return;
  try {
    
  
              const cards = document.querySelectorAll('.project__card')
  cards.forEach((card)=>{
    const status = card.querySelector('.project__card__brief')?.querySelector('.project-status')
  console.log('brief',card.querySelector('.project__card__brief'))
    if(status){
      console.log('status',status)
      card.querySelector('.project__status').innerHTML = `<b>Status:</b> ${status.innerHTML}`
    }
  })
            

  } catch(e) { console.error(e); }
})();
})();
